import debounce from "lodash.debounce";
import { FunctionComponent, useEffect, useMemo, useState } from "react";
import {
  ToastType,
  useToast,
} from "../../../context_providers/toast/toast_ctx";
import { fetchGet, toQueryString } from "../../../service/api_client";
import AutoCompleteField from "../../../ui/new_components/common/autocomplete";
import { PartyModel } from "../models/party_model";

interface PartySearchFieldProps {
  onSelect: (data: PartyModel) => void;
  disabled?: boolean;
  placeholder?: string;
  value?: PartyModel;
  status?: string;
  id?: string;
  // show_a/dd?: boolean;
}

const PartySearchField: FunctionComponent<PartySearchFieldProps> = (props) => {
  const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/accounts/party`;
  const { showToast } = useToast();
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  // const [addNew, setAddNew] = useState(false);
  const [suggestions, setSuggestions] = useState<
    {
      label: string;
      value: PartyModel;
    }[]
  >();
  const getData = async (prop: {
    name?: string;
    id?: string;
    page: number;
    count: number;
    all?: boolean;
    status?: string[];
  }) => {
    setLoading(true);
    try {
      if (props.status !== undefined || props.status !== null) {
        prop.status = [props.status ?? ""];
      }
      console.log("props : ", props);
      const res = await fetchGet(url + toQueryString(prop));
      if (res.success) {
        setSuggestions(
          res.data?.result?.map((data: PartyModel) => ({
            label: `${data.name}`,
            value: data,
          })),
        );
      } else {
        showToast({ type: ToastType.error, text: res.error });
      }
    } catch (error: any) {
      showToast({ type: ToastType.error, text: error.message });
      //   return { success: false, error: error.message };
    }
    setLoading(false);
  };

  const debouncedHandler = useMemo(() => {
    return debounce((query: string) => {
      const isLikelyId = /^VC-\d+$/i.test(query.trim());
      getData({
        [isLikelyId ? "id" : "name"]: query,
        page: 1,
        count: 1,
        all: true,
        status: [props.status ?? ""],
      });
    }, 500);
  }, [props.status]);

  useEffect(() => {
    if (search && edit) {
      if (props.value && props.value.name === search) return;
      debouncedHandler(search);
    }
  }, [search]);
  useEffect(() => {
    setSearch(props.value?.name ?? "");
  }, [props.value]);

  return (
    <>
      {edit ? (
        <AutoCompleteField
          id={props.id}
          loading={loading}
          disabled={props.disabled}
          value={search}
          onChange={setSearch}
          // onAddNew={props.show_add ? () => setAddNew(true) : undefined}
          onSelect={(d) => {
            setSearch(d.value.name);
            setEdit(false);

            props.onSelect(d.value);
          }}
          placeholder={props.placeholder || "Search party"}
          suggestions={suggestions}
        />
      ) : (
        <input
          id={props.id}
          disabled={props.disabled}
          type="text"
          placeholder={props.placeholder || "Search party"}
          className="text-sm p-1   rounded focus:outline-none w-full border cursor-text"
          onClick={() => {
            if (!props.disabled) {
              setEdit(true);
            }
          }}
          value={props.value?.name}
        ></input>
      )}
    </>
  );
};

export default PartySearchField;
